const utils = {

    /**
     * Convert a miles per hour number to meters per second
     * 
     * @param  {int} mph - Miles per hour value to convert to miles per second (ex: 40 mph)
     * @return  {int} mps - Resulting meters per second after conversion
     */
    convertMphToMps : function(mph) {
        return mph / 2.237
    },

    /**
     * Convert a number of miles to meters
     * 
     * @param  {int} miles - Miles value to convert to meters (ex: 6.6 mi)
     * @return  {int} meters - Resulting meters after conversion
     */
    convertMilesToMeters : function(miles) {
        return miles * 1609.344
    }
};

module.exports = utils;